import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import {
  CheckboxGroupInput,
  Edit,
  SimpleForm,
  useDataProvider,
  useNotify,
  useRecordContext,
  useRedirect,
} from "react-admin";
import { CLASSES, StudentServicePath } from "utils/constants";
import { useParams } from "react-router";
import { studentRequests } from "api/studentApi";
import { useEffect, useMemo, useState } from "react";
import BackButtonToolbar from "features/BackButtonToolbar";
import { administrationRequests } from "api/administrationApi";
import { useNotifyError } from "utils/useNotifyError";

const EquipmentCheckboxForm = () => {
  const record = useRecordContext();
  const params = useParams();
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const notifyError = useNotifyError();

  const equipment = Array.isArray(record) ? record : [];
  const ids = equipment.map(x => x.equipmentId);

  const [equipmentData, setEquipmentData] = useState([]);

  useEffect(() => {
    const fetchEquipment = async () => {
      if (ids.length === 0) {
        setEquipmentData([]);
        return;
      }
      try {
        const { data } = await dataProvider.getMany(administrationRequests.getTechnicalEquipmentTypesSelect(), { ids });
        setEquipmentData(data);
      } catch (err) {
        setEquipmentData([]);
      }
    };
    fetchEquipment();
  }, [dataProvider, ids.join(",")]);

  const choices = useMemo(() => {
    return equipmentData?.map(e => ({
      id: e.id,
      name: e.name,
    }));
  }, [equipmentData]);

  const defaultChecked = equipment.filter(e => e.used).map(e => e.equipmentId);

  const onSubmit = async values => {
    const checkedEquipmentIds = values?.equipments?.equipmentId ?? [];

    const body = {
      classId: Number(params.id),
      equipments: equipment.map(e => ({
        equipmentId: e.equipmentId,
        used: checkedEquipmentIds.includes(e.equipmentId),
      })),
    };

    try {
      await dataProvider.customRequest(studentRequests.updateClassEquipment(params.id), body, "PUT");
      notify("Оборудването е записано.", { type: "success" });
      redirect(`/${StudentServicePath}${CLASSES}`);
    } catch (e) {
      notifyError(e);
    }
  };

  return (
    <SimpleForm
      toolbar={<InactiveDeleteOptionEditToolbar />}
      onSubmit={onSubmit}
      defaultValues={{ equipments: { equipmentId: defaultChecked } }}
    >
      {equipment.length === 0 ? (
        "Няма намерено оборудване."
      ) : (
        <CheckboxGroupInput
          source="equipments.equipmentId"
          label="Отбележете използваното оборудване"
          choices={choices}
          optionText="name"
          optionValue="id"
          sx={{ "& .RaCheckboxGroupInput-label": { fontSize: 22, color: "primary.main", mb: 2 } }}
          row={false}
        />
      )}
    </SimpleForm>
  );
};

const UpdateEquipment = () => {
  return (
    <Edit
      redirect={`/${StudentServicePath}${CLASSES}`}
      title="Налично техническо оборудване"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <EquipmentCheckboxForm />
    </Edit>
  );
};

export default UpdateEquipment;
